import React from 'react'
import ReactDOM from 'react-dom/client'
import "src/assets/scss/main.scss"

import {  RouterProvider} from 'react-router-dom'
import { DevTools } from 'jotai-devtools'
import * as Sentry from "@sentry/react";
import { PROD, USE_SENTRY } from './utils/constants'
import { router } from './Router'
import DOMPurify from 'dompurify';
import 'jotai-devtools/styles.css'

DOMPurify.setConfig( { ADD_ATTR:["target"] } );

if (USE_SENTRY) {
    Sentry.init({
        dsn: "https://f34f2c420ade35fbd737f429b331ac33@o4507208376320000.ingest.de.sentry.io/4507973136416848",

        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/produce\.laranara\.se/],
        // Session Replay
        replaysSessionSampleRate: 0.01, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        ignoreErrors: [
            "ResizeObserver loop limit exceeded", /^No error$/,
            /__show__deepen/,
            /_avast_submit/,
            /Access is denied/,
            /anonymous function: captureException/,
            /Blocked a frame with origin/,
            /can't redefine non-configurable property "userAgent"/,
            /change_ua/,
            /console is not defined/,
            /cordova/,
            /DataCloneError/,
            /Error: AccessDeny/,
            /event is not defined/,
            /feedConf/,
            /ibFindAllVideos/,
            /myGloFrameList/,
            /SecurityError/,
            /MyIPhoneApp/,
            /snapchat.com/,
            /vid_mate_check is not defined/,
            /win\.document\.body/,
            /window\._sharedData\.entry_data/,
            /window\.regainData/,
            /ztePageScrollModule/
        ],

    });
}
else {
    window.document.title = "DEV " + window.document.title;
}


ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        { !PROD && <DevTools position='top-left' />}
        <RouterProvider router={router} />
    </React.StrictMode>,
)







